import type { en } from "./en";

export const es: { [K in keyof typeof en]: string } = {
  close: "Cerrar",
  howToPlay: "Cómo jugar",
  dash: "Dash",
  duel: "Duelo",
  ranks: "Ranking",
  garage: "Garaje",
  shop: "Tienda",
  settings: "Ajustes",
  tagline: "Mensajero neón. No choques.",
  bestMeters: "Récord {n} m · {diff}",
  pause: "Pausa",
  paused: "Pausa",
  resume: "Reanudar",
  endRun: "Terminar",
  sound: "Sonido",
  on: "On",
  off: "Off",
  muted: "Silencio",
  muteSfx: "Silenciar música y SFX",
  pbGhost: "Fantasma PB",
  ads: "Anuncios",
  adsOff: "Off",
  adsConsentOff: "{mode} · consentimiento off",
  language: "Idioma",
  langEn: "English",
  langFr: "Français",
  langIt: "Italiano",
  langEs: "Español",
  langDe: "Deutsch",
  pseudoRanks: "Pseudo (ranking)",
  pseudoHint:
    "Guardado para el ranking. Edítalo aquí cuando quieras — no después de cada carrera. No hace falta cuenta Apple.",
  gameCenter: "Game Center",
  open: "Abrir",
  gcOpening: "Abriendo Game Center…",
  gcIos: "Game Center es solo para iOS.",
  gcSignIn: "Inicia sesión en Game Center en Ajustes y reintenta.",
  gcHint: "Rankings y logros de Apple. Separado del ranking in-app.",
  signInApple: "Iniciar sesión con Apple",
  linked: "Vinculado",
  link: "Vincular",
  appleLinked: "Apple vinculado — el ranking sigue este ID.",
  appleLinkedWeb: "Apple vinculado (test web).",
  appleWaiting: "Esperando a Apple…",
  appleCancel: "Cancelado — no se vinculó nada.",
  appleFail:
    "Apple no terminó (a menudo un retraso de índice). Juega con tu pseudo y reintenta luego.",
  appleHint:
    "Opcional. Vincula el ranking a este Apple ID en tus dispositivos. No hace falta para jugar.",
  appleLinkedHint: "ID de ranking ligado a Apple. El pseudo de arriba sigue editable.",
  restorePurchases: "Restaurar compras",
  restoring: "Restaurando…",
  restored: "Compras restauradas (si las hay).",
  restoreFail: "Error al restaurar: {reason}",
  restoreIos: "Restaurar es solo para iOS.",
  appleId: "Apple ID",
  adPrivacy: "Opciones de anuncios",
  manage: "Gestionar",
  privacy: "Privacidad",
  support: "Soporte",
  settingsHint:
    "Swipe I/D para cambiar de carril. Swipe arriba para saltar — recoge fichas cyan ↑ (máx. {n}). El salto pasa barreras, cajas, agujeros y coches — no camiones. Garaje → Mundos para Luna / Magma.",
  playingAs: "Juegas como {name}",
  noPseudo: "Sin pseudo — pon uno en Ajustes",
  loading: "Cargando…",
  noScores: "Sin puntuaciones — sé el #1",
  difficultyLocked: "Dificultad bloqueada para este duelo.",
  diffNote: "Medio tras 3 carreras · Difícil tras 12. La velocidad sube en carrera.",
  diffEasy: "Fácil",
  diffMedium: "Medio",
  diffHard: "Difícil",
  hintEasy: "Relax",
  hintMedium: "Arcade",
  hintHard: "Insane",
  runsLeft: "{n} carreras",
  runLeft: "1 carrera",
  swipeHint: "Swipe I/D · swipe arriba para saltar",
  swipeHintPower: " · toca ⚡ · mantén = AUTO",
  speedUp: "SPEED UP",
  powerMagnet: "Imán",
  powerPhase: "Fase",
  powerDefault: "Poder",
  powerOn: "ON",
  powerAuto: "AUTO",
  powerHoldHint: "Toca para activar · mantén para AUTO",
  powerAria: "{label}{auto} — mantén para AUTO",
  powerAriaAuto: " (auto)",
  continueAd: "Continuar (anuncio)",
  continueFree: "Continuar (gratis)",
  continueRetry: "Reintentar",
  loadingAd: "Cargando anuncio…",
  firstContinue: "El primer continue es gratis.",
  adsRemovedContinue: "Anuncios off — continue gratis.",
  watchAd: "Mira un anuncio para otra oportunidad.",
  leftCount: "({n} restantes)",
  outOfContinues: "Sin continues.",
  duelCrash: "El primer choque termina el duelo.",
  adUnavailable: "Anuncio no disponible — reintenta o termina la carrera.",
  adsBlocked:
    "Anuncios bloqueados — actívalos en Ajustes → Opciones de anuncios y reintenta.",
  watchWholeAd: "Mira el anuncio entero para continuar.",
  crash: "¡Crash!",
  newBest: "¡Nuevo récord!",
  runOver: "Carrera terminada",
  theyCrashed: "Ellos chocaron primero",
  youCrashed: "Chocaste primero",
  deadHeat: "Empate",
  duelOver: "Duelo terminado",
  vsLasted: " — aguantaste más.",
  vsHeld: " — ellos llegaron más lejos.",
  vsSame: " — misma distancia.",
  vsLine: "vs {name} {m} m",
  resultCoins: "+{coins} monedas · Récord {best} m · {diff}",
  submitting: "Enviando…",
  pickPseudo: "Elige un pseudo para el ranking",
  offlineScore: "Sin conexión — puntuación guardada localmente",
  rankImproved: "Global #{rank} · {total} jugadores",
  rankBestStill: "Récord sigue {best} m · #{rank}",
  choosePseudo: "Elige tu pseudo",
  savePseudo: "Guardar pseudo",
  asPlayer: "como {name}",
  editSettings: " · editar en Ajustes",
  rematch: "Revancha",
  playAgain: "Jugar otra vez",
  passPhone: "Pasa el teléfono",
  shareInvite: "Compartir / Invitar",
  coinsPlus: "+{n} monedas",
  menu: "Menú",
  launchBonus: "Bonus de lanzamiento",
  welcomeTitle: "✦{n} para ti",
  welcomeBody:
    "Primera apertura de esta versión — un poco de fuel para el Garaje. Solo una vez.",
  claimCoins: "Reclamar ✦{n}",
  infoLead: "Mensajero neón en tres carriles. Llega lo más lejos que puedas — no choques.",
  controls: "Controles",
  swipeLR: "Swipe I / D",
  swipeLRDesc: " — cambiar de carril",
  swipeUp: "Swipe arriba",
  swipeUpDesc: " — saltar (hace falta una ficha)",
  continueInfo: "Continuar",
  continueInfoDesc: " — el primero es gratis, el segundo con anuncio opcional (off en duelo)",
  tapPower: "Toca ⚡",
  tapPowerDesc: " — poder del vehículo (o tecla E)",
  twoPlayers: "A 2 jugadores",
  hotseatInfo: "Pasa el teléfono",
  hotseatInfoDesc:
    " — tras una carrera, toca {pass}. Misma carretera, le toca a tu colega.",
  ranksDuelInfo: "Duelo de ranking",
  ranksDuelInfoDesc:
    " — {ranks} → {duel} en una puntuación. Corres exactamente su carretera.",
  shareInfo: "Enlace de invitación",
  shareInfoDesc:
    " — tras una carrera, {share}. Tu colega abre el enlace y corre tu carretera.",
  twoPlayersRule:
    "Mismos obstáculos, misma semilla. El primero que choca pierde — sin continues en duelo.",
  boardHint:
    "Toca {duel} en una puntuación para correr la misma carretera — el primero que choca pierde.",
  resultTwoP: "Jugar con un amigo",
  obstacles: "Obstáculos",
  rivalBikes: "Motos rivales",
  rivalDesc: "Sáltalas — frenan detrás de cajas y barreras.",
  trucks: "Camiones",
  truckDesc: "Demasiado altos para saltar. Cambia de carril.",
  barriers: "Barreras",
  barrierDesc: "Sáltalas si tienes una ficha.",
  crates: "Cajas",
  crateDesc: "El salto las pasa (algunos coches las rompen).",
  collectibles: "Coleccionables",
  coinsTitle: "Monedas (✦)",
  coinsDesc: "Gástalas en el Garaje para desbloquear coches.",
  jumpTokens: "Fichas de salto",
  jumpDesc: "Guarda hasta {n} — swipe arriba para usarlas.",
  infoFoot:
    "La velocidad sube durante la run. Elige dificultad antes de Dash. {garage} = coches y mundos. {ranks} = puntuaciones y duelos. Las misiones del día pagan ✦.",
  missions: "Misiones {done}/{total}",
  missionsReady: " · reclamar",
  claimed: "Reclamado",
  playToStreak: "Juega para la racha",
  dayN: "Día {n}",
  streakClaim: "Reclamar ✦{n}",
  streakToast: "Racha +✦{n}",
  missionToast: "Misión +✦{n}",
  missionClaim: "Reclamar ✦{n}",
  missionDone: "Hecho",
  shopTitle: "Tienda",
  noAds: "Sin anuncios",
  noAdsBlurb: "Banners e intersticiales off. Restaurar sigue funcionando.",
  phantomPack: "Pack Phantom GT",
  phantomPackBlurb: "Phantom GT · ✦{n} · Sin anuncios",
  phantomPackGranted: " — ya concedido.",
  phantomPackShort: "Pack Phantom GT · {price}",
  coinPouch: "Bolsa de monedas",
  coinChest: "Cofre de monedas",
  coinPackBlurb: "✦{n} para coches y mundos.",
  owned: "Comprado",
  adsRemoved: "Anuncios quitados.",
  adsRemovedWeb: "Anuncios quitados (test web).",
  starterUnlocked: "Starter Pack desbloqueado.",
  starterUnlockedWeb: "Starter desbloqueado (test web).",
  coinsGranted: "+✦{n} · saldo ✦{balance}",
  rides: "Coches",
  worlds: "Mundos",
  statSpeed: "Velocidad",
  statJump: "Salto",
  statCoins: "Monedas",
  noSpecialPower: "Sin poder especial",
  passive: "Pasivo",
  active: "Activo",
  equip: "Equipar",
  equipped: "Equipado",
  tryRide: "Probar",
  tryRideHint: "Sin monedas ni ranking — solo una prueba.",
  practiceHud: "TEST",
  practiceOver: "Prueba",
  practiceNote: "No cuenta — sin monedas, sin ranking.",
  practiceCrash: "Prueba terminada — sin monedas, sin ranking.",
  tryAgain: "Probar otra vez",
  backGarage: "Garaje",
  getInShop: "En la tienda",
  needMore: "Faltan ✦{n}",
  buyPrice: "Comprar · ✦ {n}",
  haveCoins: "✦ {price} · Tienes {have}",
  buyCoinsShop: "Comprar monedas",
  baseCoins: "Monedas base",
  extraCoins: "+{pct}% monedas",
  higherJump: " · salto más alto",
  jumpHoles: " · salta los agujeros",
  prevVehicle: "Vehículo anterior",
  nextVehicle: "Vehículo siguiente",
  prevWorld: "Mundo anterior",
  nextWorld: "Mundo siguiente",
  duelBanner:
    "Duelo vs {name} · {m} m · {diff} · {stage} — misma carretera, el primero que choca pierde.",
  cancel: "Cancelar",
  vsHud: "vs {name} {m}m",
  iapProductUnavailable:
    "Producto no disponible: Apple aún no ha aprobado el IAP (Ready to Submit). Los productos ya existen — no los recrees. Salen a la venta tras la review.",
  iapStoreUnavailable:
    "Tienda no disponible — reintenta en un dispositivo real con un Apple ID sandbox.",
  iapFailed: "Compra fallida: {reason}",
  shareDialog: "Compartir e invitar amigos",
  shareCopied: "¡Puntuación + enlace de invitación copiados!",
  shareNamed:
    "{who} dashó {meters}m{diff} en 3Dash — el primero que choca pierde.{challenge}",
  shareAnon:
    "Dashé {meters}m y pillé {coins} monedas en 3Dash{diff}. ¡Supera mi run!{challenge}",
  shareChallenge: " Misma carretera: {url}",
  mission_play3: "Termina 3 carreras",
  mission_reach400: "Llega a 400 m en una carrera",
  mission_coins20: "Recoge 20 monedas hoy",
  mission_jumps8: "Salta 8 veces hoy",
  mission_beatBest: "Bate tu récord",
  veh_dash_blurb: "Hoverbike de serie. Equilibrada y gratis.",
  veh_bulldog_blurb: "Chasis pesado. Lento, pero las cajas no tienen chance.",
  veh_falcon_blurb: "Chasis ligero, hecho para volar.",
  veh_magneto_blurb: "Aspirador de monedas para farm largo.",
  veh_wasp_blurb: "Chasis aguijón. Más rápido, más nervioso, sin trucos.",
  veh_phantom_blurb: "Velocidad máxima. Atraviesa todo — un instante.",
  pow_none: "Sin poder especial.",
  pow_none_wasp: "Sin poder — solo ritmo.",
  pow_crush: "Aplasta cajas al impacto. Barreras y rivales siguen haciendo daño.",
  pow_glider: "Planeador — salto +60% más largo y más alto.",
  pow_magnet: "Imán de monedas 6s. Recarga 20s.",
  pow_phase: "Fase 3s — atraviesa todos los obstáculos. Recarga 30s.",
  stage_neon: "Neon City",
  stage_lunar: "Lunar Dust",
  stage_volcano: "Magma Run",
  stage_ice: "Ice Flats",
  stage_neon_blurb: "Carriles mojados. El run clásico de 3Dash.",
  stage_lunar_blurb: "Poca gravedad — los saltos flotan. +25% monedas.",
  stage_volcano_blurb: "Grietas de lava — salta los agujeros. +50% monedas.",
  stage_ice_blurb: "Velocidad blanca. Saltos largos, agujeros de hielo. +20% monedas.",
};
